import ReadSmore from '../../src'

const readMores = document.querySelectorAll('.js-read-smore')
// eslint-disable-next-line new-cap
const RMs = ReadSmore(readMores)

RMs.init()
